<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <!-- section 1 -->
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> รายละเอียด
          <span class="theme-color-one txt-normal">(โปรดระบุ)</span>
        </div>

        <!-- Form 1 -->
        <div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">ชื่อหน่วยงาน<span class="theme-color-seven txt-normal">
                  *
                </span></div>
              <TextField
                theme="3"
                :value="form.department_name"
                @onChange="setFormField('department_name', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">ชื่อโครงการ(ไทย)<span class="theme-color-seven txt-normal">
                  *
                </span></div>
              <TextField
                theme="3"
                :value="form.project_name_th"
                @onChange="setFormField('project_name_th', $event)"
              ></TextField>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!-- section 2 -->
    <divcard>
      <div class="txt-head black--text d-flex justify-space-between">
        <div>
          2. กิจกรรม
        </div>

        <Button theme="6" :disabled="partTwoEditMode" @onClick="addNewEvent">
          + เพิ่มกิจกรรม
        </Button>
      </div>

      <div class="card-part">
        <div class="d-flex theme-color-eight px-3 mb-3 gap-12">
          <div style="width: 8%">จัดการ</div>
          <div style="width: 35%">รายการ</div>
          <div style="width: 29%">รายละเอียด</div>
        </div>

        <div class="d-flex flex-column gap-16">
          <div v-for="(item, i) in form.operating_activities" :key="i" class="budget-item">
            <div class="d-flex black--text gap-12">
              <div style="width: 8%">
                <v-btn small icon @click="editOA(i)">
                  <Iconify
                    icon="material-symbols:edit"
                    color="var(--theme-color-seven)"
                  ></Iconify>
                </v-btn>
              </div>
              <div style="width: 35%">{{ item.activity }}</div>

              <div
                style="width: 29%"
                v-html="
                  item.description
                    ? item.description.replace(/\n/g, '<br>')
                    : '-'
                "
              >
                <!--              {{item.description}}-->
              </div>

              <v-btn absolute top right small icon @click.stop="deleteOA(i)">
                <Iconify
                  icon="mdi:close-circle"
                  color="var(--theme-color-seven)"
                ></Iconify>
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <div v-if="partTwoEditMode" class="card-part">
        <div class="d-flex gap-16 mb-3">
          <div style="min-width: 500px">
            <div class="black--text mb-3">กิจกรรม</div>

            <TextField
              theme="3"
              :value="tempOA.activity"
              @onChange="tempOA.activity = $event"
            ></TextField>
          </div>
        </div>

        <div class="d-flex gap-16 mb-3">
          <div style="min-width: 500px">
            <div class="black--text mb-3">รายละเอียด</div>

            <TextArea
              hide-scroll
              theme="3"
              :value="tempOA.description"
              @onChange="tempOA.description = $event"
            ></TextArea>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button
            min-width="80px"
            theme="2"
            @onClick="partTwoEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveOA">ยืนยัน </Button>
        </div>
      </div>
    </divcard>

    <!-- section 3 -->
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          3. ผู้รายงานผล
          <span class="theme-color-one txt-normal">(โปรดระบุ)</span>
        </div>

        <!-- Form 1 -->
        <div>
          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อผู้รายงาน
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                theme="3"
                :value="form.reporter_name"
                :rules="nameRules"
                @onChange="setFormField('reporter_name', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ตำแหน่ง
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <SelectBox
                theme="3"
                placeholder="โปรดระบุ"
                hide-details
                clearable
                :value="form.position"
                :items="masterData.masterData?.positions || []"
                item-text="name" item-value="name"
                :rules="positionsRules"
                @onChange="form.position = $event"
            ></SelectBox>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">สังกัด
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <SelectBox
                theme="3"
                placeholder="โปรดระบุ"
                hide-details
                clearable
                :value="form.department"
                :items="masterData.masterData?.institutes || []"
                item-text="name" item-value="name"
                :rules="orgRules"
                @onChange="form.department = $event"
            ></SelectBox>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์
              </div>
              <TextField
                placeholder="02XXXXXXX"
                theme="3"
                input-type="number"
                :value="form.phone"
                @onChange="setFormField('phone', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                โทรสาร
              </div>
              <TextField
                theme="3"
                input-type="number"
                :value="form.fax"
                @onChange="setFormField('fax', $event)"
              ></TextField>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์มือถือ
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                placeholder="09XXXXXXXX"
                theme="3"
                input-type="number"
                :rules="mobilePhoneRules"
                :value="form.mobile_phone"
                @onChange="setFormField('mobile_phone', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                E-mail
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                theme="3"
                :rules="emailRules"
                :value="form.email"
                @onChange="setFormField('email', $event)"
              ></TextField>
            </div>
          </div>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import { eventBus, validateEmail } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import Button from "../../../components/input/Button";
import TextArea from "../../../components/input/TextArea";
import SelectBox from "../../../components/input/SelectBox";

export default {
  name: "FundamentalFormDetail",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    Button,
    TextArea,
    SelectBox
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      form: {
        operating_activities: [],
      },
      mobilePhoneRules: [
        (v) => !!v || "",
      ],
      emailRules: [
        (v) => !!v || "",
        (v) => validateEmail(v) || "อีเมลไม่ถูกต้อง",
      ],
      nameRules: [
        (v) => !!v || "กรุณากรอกชื่อหน่วยงาน",
        (v) => v.length <= 100 || "ชื่อหน่วยงานต้องไม่เกิน 100 ตัวอักษร",
      ],
      positionsRules: [
        (v) => !!v || "กรุณาเลือกตำแหน่ง",
      ],
      orgRules: [
        (v) => !!v || "กรุณาเลือกสังกัด",
      ],
      partTwoEditMode: false,
      tempOA: {},
      positionItems: [],
      instituteItems: [],
    };
  },
  computed: {
    ...mapState({
      GeneralForm: (state) => state.AForm.GeneralForm,
    }),
  },
  created() {
    // if (this.isSameId && !this.masterData.form_b) this.form = this.GeneralForm;
    // this.form.sci_park = this.masterData.region;
    // if (this.masterData.form_b) {
    //   this.form = this.masterData.form_b.form_ab_general_info;
    // }
      if (this.masterData) {
        let formDetailData = {
          department_name: this.masterData?.formFund?.department_name,
          project_name_th: this.masterData?.formFund?.project_name_th,
          reporter_name: this.masterData?.formFund?.reporter_name,
          position: this.masterData?.formFund?.position,
          department: this.masterData?.formFund?.department,
          phone: this.masterData?.formFund?.phone,
          fax: this.masterData?.formFund?.fax,
          mobile_phone: this.masterData?.formFund?.mobile_phone,
          email: this.masterData?.formFund?.email,
          status: this.masterData?.formFund?.status,
          form_fund_group_id: this.masterData?.formFund?.form_fund_group_id,
          operating_activities: this.masterData?.formFund?.operating_activities || [],
        };
        this.form = {
          ...formDetailData,
        };
      } 

    eventBus.$on("fundamentalFormDetail", () => {
      eventBus.$emit("fundamentalFormDetailSend", this.form);
    });
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },

    addNewEvent() {
      this.partTwoEditMode = true;
    },
    editOA(index) {
      console.log("editOA s!!!");
      this.tempOA = {
        ...this.removeVModel(this.form.operating_activities[index]),
        temp_index: index,
      };
      this.partTwoEditMode = true;
      console.log("editOA !!!");
    },
    removeVModel (item) {
      return JSON.parse(JSON.stringify(item))
    },
    saveOA() {
      this.partTwoEditMode = false;
      if (this.tempOA.temp_index !== undefined) {
        this.form.operating_activities[this.tempOA.temp_index] = this.removeVModel(this.tempOA);
      } else {
        this.form.operating_activities.push(this.tempOA);
      }
      this.tempOA = {};
    },
    deleteOA(index) {
      this.form.operating_activities.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.budget-item,
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
  border: solid 1px transparent;
  cursor: pointer;
  position: relative;
}

.budget-item-active {
  border-color: var(--theme-color-seven);
}
</style>
